
import { useState } from "react";
import { Box, Typography, useTheme, Button, Paper } from "@mui/material";
import { tokens } from "../../theme";

const CodeEditor = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  
  const [code, setCode] = useState("// Start editing your code here");
  
  const handleSave = () => {
    console.log("Saving code:", code);
    // Here you would implement saving to backend
  };

  return (
    <Box sx={{ p: 0 }}>
      <Box 
        sx={{ 
          display: "flex", 
          alignItems: "center", 
          justifyContent: "space-between",
          p: 2,
          borderBottom: `1px solid ${theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.1)"}`,
        }}
      >
        <Typography 
          variant="h5" 
          sx={{ 
            color: colors.grey[100], 
            fontWeight: 500 
          }}
        >
          Code Editor App
        </Typography>
      </Box>
      
      <Box 
        sx={{ 
          backgroundColor: "#1e1e1e", 
          height: "calc(100vh - 170px)",  // Adjust based on your layout
          position: "relative"
        }}
      >
        <Box sx={{ display: "flex", height: "100%" }}>
          {/* Line numbers */}
          <Box 
            sx={{ 
              width: "40px", 
              backgroundColor: "#252525",
              color: "#858585",
              textAlign: "right",
              p: 1,
              fontFamily: "monospace",
              fontSize: "14px",
              borderRight: "1px solid #333",
              overflowY: "auto",
              userSelect: "none",
            }}
          >
            {Array.from({ length: 100 }, (_, index) => (
              <Box key={index} sx={{ px: 1 }}>
                {index + 1}
              </Box>
            ))}
          </Box>
          
          {/* Editor area */}
          <textarea
            value={code}
            onChange={(e) => setCode(e.target.value)}
            style={{
              width: "100%",
              height: "100%",
              backgroundColor: "#1e1e1e",
              color: "#d4d4d4",
              border: "none",
              outline: "none",
              padding: "8px",
              fontFamily: "monospace",
              fontSize: "14px",
              resize: "none",
              lineHeight: "1.5",
            }}
          />
        </Box>
      </Box>
      
      <Box 
        sx={{ 
          p: 1,
          borderTop: `1px solid ${theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.1)"}`,
          display: "flex",
          justifyContent: "flex-start",
        }}
      >
        <Button
          variant="contained"
          onClick={handleSave}
          sx={{
            backgroundColor: "#009CAD",
            color: "#fff",
            "&:hover": {
              backgroundColor: "#007D8A",
            },
            fontWeight: 600,
            textTransform: "uppercase",
          }}
        >
          Save
        </Button>
      </Box>
    </Box>
  );
};

export default CodeEditor;
